import Link from 'next/link';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { BlogHomepageCardCategoryProps } from 'src/types';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';

const CategoryCard = (props: BlogHomepageCardCategoryProps) => {
  const { name, slug, image, postCount, platform, browser } = props;
  return (
    <Link href="/blog/category/[slug]" as={`/blog/category/${slug}/`}>
      <a
        className={ivclass(
          'iv-relative',
          'iv-flex iv-justify-end iv-flex-col',
          'iv-px-[38px] iv-py-[34px] ',
          'sm:iv-pb-20',
          'sm:iv-px-[24px]',
          'iv-rounded-[25px]',
          'iv-h-[560px] sm:iv-h-[450px] iv-w-[380px] sm:iv-w-[320px]',
          'iv-bg-no-repeat iv-bg-cover iv-bg-center',
          'iv-cursor-pointer',
          'iv-bg-gradient-to-t iv-from-black-20 iv-to-transparent',
        )}
      >
        <ImageComponent
          elementype="imagekit"
          src={image?.url || ''}
          alt={name}
          loading="lazy"
          className={ivclass(
            'iv-absolute iv-top-0 iv-left-0 iv-z-[-1]',
            'iv-h-full iv-w-full',
            'iv-object-cover',
            'iv-rounded-[25px]',
          )}
        />
        <span
          className={ivclass(
            'iv-text-heading-xs iv-font-extrabold',
            'sm:iv-text-heading-3xs',
            'iv-max-w-[280px] sm:iv-max-w-[200px]',
            'iv-text-grey-0',
            'iv-mb-10 sm:iv-mb-[0]',
          )}
        >
          {name}
        </span>
        <span
          className={ivclass(
            'xl:iv-text-body-3xl xl:iv-font-medium',
            'md:iv-text-body-2xl md:iv-font-medium',
            'sm:iv-text-body-xl sm:iv-font-medium',
            'iv-text-white-60',
          )}
        >
          {`${postCount} posts`}
        </span>
      </a>
    </Link>
  );
};

export default CategoryCard;
